import {
  fetchVoucherData,
  resetVoucherData,
} from 'app/pages/TicketSalePage/slice';
import { selectVoucherData } from 'app/pages/TicketSalePage/slice/selectors';
import { Check, Loader2 } from 'lucide-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { selectCartData } from 'store/cartSlice/selectors';
import { toastOptions } from 'utils/static/constants';
import { Button } from '../ui/button';
import { useParams } from 'react-router-dom';
import { getEventIdFromSlug } from 'utils/events';

const voucherCode = 'HEROES2025';
// const voucherCode = 'vet';

const IdMeSection = () => {
  const dispatch = useDispatch();
  const { uuid } = useSelector(selectCartData);
  const { eventSlug } = useParams();
  const eventId = getEventIdFromSlug(eventSlug);
  const {
    loading,
    status,
    voucherError,
    voucherData: { id: voucherId },
  } = useSelector(selectVoucherData);
  const isValid = !!(status === 'valid' && (voucherId || voucherError));

  const getVoucherData = async () => {
    try {
      const response = await dispatch(
        fetchVoucherData({
          eventId,
          voucherCode,
          uuid,
        }),
      );
      if (response.payload.voucher_error) {
        toast.error(response.payload.voucher_error, toastOptions);
      } else {
        toast.success('Voucher applied', toastOptions);
      }
    } catch (error) {
      toast.error('An error occurred', toastOptions);
    }
  };

  const handleRemoveDiscount = () => {
    dispatch(resetVoucherData());
    toast.warning('Voucher removed', toastOptions);
  };

  return (
    <div>
      <p className="p2-regular mb-2">
        <b>Please note:</b> Valid military or first responder ID must be
        presented at the door when using this discount.
      </p>
      {isValid ? (
        <Button
          variant="ghost"
          onClick={handleRemoveDiscount}
          className="text-red-600 bg-red-200/50 hover:text-red-600 hover:bg-red-200/100"
        >
          Remove discount
        </Button>
      ) : (
        <Button
          className="bg-green-600 hover:bg-green-700"
          onClick={getVoucherData}
          disabled={loading}
        >
          {loading ? <Loader2 className="animate-spin" /> : <Check />} Claim 10%
          discount
        </Button>
      )}
    </div>
  );
};

export default IdMeSection;
